/** Parse an elapsed duration to whole seconds; null denotes invalid input. */
export function parseDurationSeconds(input: string): number | null {
  const value = input.trim().toLowerCase();
  if (!value) return null;
  let seconds: number;

  if (/^\d+$/.test(value)) {
    seconds = Number(value);
  } else if (/^\d+:\d{1,2}(?::\d{1,2})?$/.test(value)) {
    const parts = value.split(":").map(Number);
    if (parts.at(-1)! >= 60 || (parts.length === 3 && parts[1] >= 60)) {
      return null;
    }
    seconds = parts.reduce((total, part) => total * 60 + part, 0);
  } else {
    // Units must occur in descending order and be present at most once.
    const match = value.match(
      /^(?:(\d+)\s*(?:hours?|hrs?|h))?\s*(?:(\d+)\s*(?:minutes?|mins?|m))?\s*(?:(\d+)\s*(?:seconds?|secs?|s))?$/
    );
    if (!match || !match.slice(1).some(part => part !== undefined)) return null;
    seconds =
      Number(match[1] ?? 0) * 3600 +
      Number(match[2] ?? 0) * 60 +
      Number(match[3] ?? 0);
  }

  return Number.isSafeInteger(seconds) && seconds >= 1 && seconds <= 86400
    ? seconds
    : null;
}
